import { getI18n } from 'react-i18next';

export const VALIDATION_COUNTRY_CODE_ALREADY_IN_USE = 'validation.country.codeAlreadyInUse';
export const VALIDATION_COUNTRY_EMPTY_CODE = 'validation.country.emptyCode';
export const VALIDATION_COUNTRY_INVALID_CODE_LENGTH = 'validation.country.invalidCodeLength';
export const VALIDATION_COUNTRY_INVALID_CODE = 'validation.country.invalidCode';
export const VALIDATION_COUNTRY_NAME_ALREADY_IN_USE = 'validation.country.nameAlreadyInUse';
export const VALIDATION_COUNTRY_EMPTY_NAME = 'validation.country.emptyName';
export const VALIDATION_COUNTRY_INVALID_NAME_LENGTH = 'validation.country.invalidNameLength';
export const VALIDATION_COUNTRY_EXISTING_DATA_TEMPLATE = 'validation.country.existingTemplate';
export const VALIDATION_COUNTRY_IMMUTABLE_CODE = 'validation.country.immutableCode';
export const VALIDATION_COUNTRY_IMMUTABLE_NAME = 'validation.country.immutableName';
export const ERROR_COUNTRY_NOT_FOUND = 'country.notFound';
export const ERROR_COUNTRY_CANNOT_BE_DEACTIVATED = 'country.noDeactivation';
export const ERROR_COUNTRY_INVALID_SORT_KEY = 'country.sort.invalidField';

export const createCountryErrorMessage = (code, params) => { // NOSONAR javascript:S3800
    let result;
    const i18n = getI18n();
    switch (code) {
        case VALIDATION_COUNTRY_CODE_ALREADY_IN_USE:
            result = i18n.t('countries.error.country-code-already-used');
            break;
        case VALIDATION_COUNTRY_EMPTY_CODE:
            result = i18n.t('countries.error.country-empty-code');
            break;
        case VALIDATION_COUNTRY_INVALID_CODE_LENGTH:
            result = i18n.t('countries.error.country-invalid-code-length', { max: params[0], min: params[1] });
            break;
        case VALIDATION_COUNTRY_INVALID_CODE:
            result = i18n.t('countries.error.country-invalid-code');
            break;
        case VALIDATION_COUNTRY_NAME_ALREADY_IN_USE:
            result = i18n.t('countries.error.country-name-already-used');
            break;
        case VALIDATION_COUNTRY_EMPTY_NAME:
            result = i18n.t('countries.error.country-empty-name');
            break;
        case VALIDATION_COUNTRY_INVALID_NAME_LENGTH:
            result = i18n.t('countries.error.country-invalid-name-length', { maxLength: params[0] });
            break;
        case VALIDATION_COUNTRY_EXISTING_DATA_TEMPLATE:
            result = i18n.t('countries.error.country-existing-data-template');
            break;
        case VALIDATION_COUNTRY_IMMUTABLE_CODE:
            result = i18n.t('countries.error.country-immutable-code');
            break;
        case VALIDATION_COUNTRY_IMMUTABLE_NAME:
            result = i18n.t('countries.error.country-immutable-name');
            break;
        case ERROR_COUNTRY_NOT_FOUND:
            result = i18n.t('countries.error.country-not-found');
            break;
        case ERROR_COUNTRY_CANNOT_BE_DEACTIVATED:
            result = i18n.t('countries.error.country-cannot-be-deactivated');
            break;
        case ERROR_COUNTRY_INVALID_SORT_KEY:
            result = i18n.t('countries.error.country-invalid-sort-key', { sortKey: params[0] });
            break;
        default:
            result = undefined;
    }
    return result;
};
